


































































import { computed, defineComponent, ref } from '@vue/composition-api';
import { useGroups } from '@/store/modules/group';
import { Address, ContactPoint, Field, Group, ResourceMeta } from '@/store/types';
import { hasMinimumLength, isNotEmpty } from '@/utils/rules';
import GroupCreateForm from '../../group/GroupCreateForm.vue';
import AddressForm from '../FieldEdit/AddressForm.vue';
import ContactPointsForm from '../FieldEdit/ContactPointsForm.vue';

export default defineComponent({
	components: { AddressForm, ContactPointsForm, GroupCreateForm },
	emits: ['submit', 'cancel'],
	props: {
		cancelButton: {
			type: String,
		},
	},
	setup(props, { root, emit }) {
		const isFormValid = ref<boolean>(false);
		const name = ref<string>('');
		const producerName = ref<string>('');
		const group = ref<string>('');
		const address = ref<Address>();
		const contactPoints = ref<Array<ContactPoint>>([]);
		const isCreateGroupOpen = ref<boolean>(false);
		const form = ref();

		const { isLoading: groupsAreLoading, groups } = useGroups(root.$store);

		const field = computed<Partial<Field>>(() => ({
			name: name.value,
			producerName: producerName.value,
			address: address.value,
			contactPoints: contactPoints.value,
			meta: {
				groupId: group.value,
			} as ResourceMeta,
		}));

		const handleSubmit = async () => {
			form.value.validate();

			if (!isFormValid.value) {
				return;
			}

			emit('submit', field.value);
		};

		const openCreateGroup = () => {
			isCreateGroupOpen.value = true;
		};

		const cancelCreateGroup = () => {
			isCreateGroupOpen.value = false;
		};

		const handleGroupCreateSuccess = async (createdGroup: Group) => {
			root.$store.dispatch('groups/getGroups');
			isCreateGroupOpen.value = false;
			group.value = createdGroup.id;
		};

		return {
			isFormValid,
			name,
			producerName,
			group,
			address,
			contactPoints,
			groupsAreLoading,
			groups,
			handleSubmit,
			hasMinimumLength,
			isNotEmpty,
			isCreateGroupOpen,
			openCreateGroup,
			cancelCreateGroup,
			handleGroupCreateSuccess,
			form,
		};
	},
});
